import {
  DetailedLabResult,
  DocumentBasedLabResult,
  LabKit,
  LabRequisition,
  LabWork,
} from '@pm/graphql';

export const isLabKit = (labWork: LabWork): labWork is LabKit => {
  return '__typename' in labWork && labWork.__typename === 'LabKit';
};

export const isLabReq = (labWork: LabWork): labWork is LabRequisition => {
  return '__typename' in labWork && labWork.__typename === 'LabRequisition';
};

export const isLabResult = (
  labWork: LabWork,
): labWork is DocumentBasedLabResult => {
  return (
    '__typename' in labWork && labWork.__typename === 'DocumentBasedLabResult'
  );
};

export const isLabDetail = (labWork: LabWork): labWork is DetailedLabResult => {
  return '__typename' in labWork && labWork.__typename === 'DetailedLabResult';
};

export const supportsFeedback = (labWork: LabWork) => {
  return 'feedbackStep' in labWork && labWork.feedbackStep != null;
};
